module.exports = __webpack_public_path__ + "static/media/Alert-orange.d526a875.svg";